export const getYouTubeVideoId = (video) => (
  video?.id?.videoId || video?.videoId || (typeof video?.id === 'string' ? video.id : '')
);

export const decodeYouTubeText = (value = '') => {
  if (typeof document === 'undefined') return String(value);
  const element = document.createElement('textarea');
  element.innerHTML = String(value);
  return element.value;
};

export const youtubeThumbnail = (video) => (
  video?.snippet?.thumbnails?.medium?.url
  || video?.snippet?.thumbnails?.default?.url
  || ''
);
